import { BaseModel } from './base';

export class CustomField extends BaseModel {
  idCustomField!: number;
  id!: number;
  dataType!: CustomFieldDataType;
  modelType?: CustomFieldModelType;
  name!: string;
  code!: string;
  customerVisible!: boolean;
  customerEditable!: boolean;
  values!: string;
  multipleValues!: string[];
  value!: string;
  valueLabel!: string;

  override objectID(): string {
    return this.idCustomField?.toString() || '';
  }

  get isDataTypeText () {
    return this.dataType === CustomFieldDataType.text
  }

  get isDataTypeLongText () {
    return this.dataType === CustomFieldDataType.longtext
  }

  get isDataTypeMultiple () {
    return this.dataType === CustomFieldDataType.multiple
  }

  get isDataTypeBool () {
    return this.dataType === CustomFieldDataType.bool
  }

  get isDataTypeNumber () {
    return this.dataType === CustomFieldDataType.number
  }

  get isDataTypeDate () {
    return this.dataType === CustomFieldDataType.date
  }
} 

export enum CustomFieldModelType {
  customer = 0,
  reservation = 1,
  order = 2,
  employee = 3,
  service = 4,
  product = 5,
  reservationCustomer = 6,
}

export const CustomFieldModelTypeLabels: Record<CustomFieldModelType, string> = {
  [CustomFieldModelType.customer]: 'general.customer',
  [CustomFieldModelType.reservation]: 'general.appointment',
  [CustomFieldModelType.order]: 'general.sale',
  [CustomFieldModelType.employee]: 'general.employee',
  [CustomFieldModelType.service]: 'general.service',
  [CustomFieldModelType.product]: 'general.product',
  [CustomFieldModelType.reservationCustomer]: 'api.models.customField.groupCustomer',
}

export enum CustomFieldDataType {
  text = 0,
  longtext = 1,
  multiple = 2,
  bool = 3,
  number = 4,
  date = 5,
}

export const CustomFieldDataTypeLabels: Record<CustomFieldDataType, string> = {
  [CustomFieldDataType.text]: 'field.text',
  [CustomFieldDataType.longtext]: 'field.longText',
  [CustomFieldDataType.multiple]: 'field.multipleValues',
  [CustomFieldDataType.bool]: 'field.yesNo',
  [CustomFieldDataType.number]: 'field.number',
  [CustomFieldDataType.date]: 'field.date',
}; 